import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent, InfoDialogContentComponent } from '@iw/common';

@Component({
  selector: 'iw-cancel-confirm-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './cancel-confirm-dialog.component.scss',
  templateUrl: './cancel-confirm-dialog.component.html',
  imports: [
    IconModule,
    ButtonComponent,
    TranslateModule,
    InfoDialogContentComponent,
  ],
})
export class CancelConfirmDialogComponent {
  readonly #dialogRef = inject(DialogRef);

  confirm() {
    this.#dialogRef.close(true);
  }

  cancel() {
    this.#dialogRef.close();
  }
}
